/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '../../../components/ui/button'
import { Page } from '../../../components/layouts/page'
import { Column } from '../../../components/layouts/columns'
import { Path } from '../../../router/paths'
import { Input } from '../../../components/ui/input'
import { Form } from '../../../components/ui/form'
import { useGlobalContext } from '../../../context/ContextGlobal'
import { addDocument, getDocument, getDocumentsWithQuerys } from '../../../firebase/firestore'
import { TimestampNow } from '../../../utils/dates'
import { TryCatch } from '../../../utils/general'
import { logIn } from '../../../firebase/auth'
import { AlertFunctional } from '../../../components/ui/alert/AlertFunctional'

const newAuthenticationWeb = async (path, email, password) => {
  const querys = [
    { value: email, operator: '==', field: 'email' },
    { value: password, operator: '==', field: 'pw' },
  ]
  const getExistAuthenticToken = await getDocumentsWithQuerys('_authentications', querys, 1)

  if ((getExistAuthenticToken ?? []).length > 0) {
    return `/colaborador/confirmdelete/${getExistAuthenticToken[0].id}${path}`
  }

  const newAuth = {
    email,
    pw: password,
    dt_created: TimestampNow(),
  }

  const tokenAuth = await addDocument('_authentications', newAuth)

  return `/colaborador/confirmdelete/${tokenAuth}${path}`
}

const DeleteAccount = () => {
  const { alerts, setAlerts, loading, setLoading, setUser, setFormContext, setDataContext } = useGlobalContext()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const navigate = useNavigate()

  const Login = async () => {
    const response = await logIn(email, password)
    if (response.success) {
      const uuid = response.success.uid
      try {
        await getDocument('colaboradores', uuid)
      } catch (e) {
        throw new Error('Esse acesso é somente para colaboradores, acesse a area do cliente')
      }

      const newUrl = await newAuthenticationWeb('', email, password)
      return navigate(`${newUrl}/${uuid}`)
      // Redirecionar ou fazer o que for necessário após o login
    } else {
      throw new Error('Usuário ou Senha Incorreta')
    }
  }

  const handleLogin = async () => {
    await TryCatch(Login, setLoading, setAlerts)
  }

  useEffect(() => {
    setLoading(false)
    setUser({})
    setDataContext([])
    setFormContext({})
  }, [])

  return (
    <Page.Root>
      <Page.Content>
        <div>
          <Column.Root className="mt-6" style={{ color: 'rgb(151, 151, 151)' }}>
            <Column.Content style={{ padding: '0 2rem 0 2rem' }}>
              <h1 className="title is-size-3 has-text-centered">Exclusão de Conta</h1>

              <p className="subtitle is-size-5 mt-4">
                A exclusão da sua conta é uma ação permanente. Antes de prosseguir, recomendamos que você leia
                atentamente as informações abaixo para entender as implicações dessa decisão.
              </p>

              <h2 className="subtitle is-size-4 mt-6">1. O que acontece com seus dados?</h2>
              <p>
                Ao excluir sua conta, todas as suas informações pessoais armazenadas em nossos sistemas, como nome,
                e-mail e dados associados ao uso do aplicativo, serão permanentemente removidas ou anonimizadas, exceto
                quando houver obrigações legais que exijam a retenção de determinados dados por um período específico.
                Não vendemos nem alugamos suas informações pessoais a terceiros. Podemos compartilhar suas informações
                com parceiros de confiança para melhorar a experiência do usuário, mas sempre sob acordos de
                confidencialidade.
              </p>

              <h2 className="subtitle is-size-4 mt-6">2. E possível reverter a ação?</h2>
              <p>
                Não. A exclusão é definitiva e não pode ser desfeita. Caso deseje voltar a utilizar nossos serviços,
                será necessário criar uma nova conta.
              </p>

              <h2 className="subtitle is-size-4 mt-6">3. Qual o prazo para exclusão completa?</h2>
              <p>
                A remoção completa dos seus dados será feita em até 7 dias, conforme nossos procedimentos internos de
                segurança e backups.
              </p>

              <h2 className="subtitle is-size-4 mt-6">4. Como proceder com a exclusão?</h2>
              <p>
                Se você tiver certeza de que deseja excluir sua conta, basta inserir seu e-mail e senha nos campos
                abaixo e confirmar a exclusão. Caso tenha dúvidas ou deseje suporte durante esse processo, entre em
                contato conosco pelo e-mail: keapstaff@gmail.com
              </p>

              <Form.Root
                action={() => {}}
                className="mt-6"
                style={{
                  width: '100%',
                  maxWidth: '400px',
                  margin: '0 auto',
                }}
              >
                <Input.Root className="mt-2">
                  <Input.Label className="has-text-grey pl-5" style={{ marginBottom: 0 }} htmlFor="email">
                    E-mail
                  </Input.Label>
                  <Input.Prompt
                    id="email"
                    className="is-rounded"
                    placeholder="Digite seu e-mail"
                    required
                    value={email}
                    setValue={setEmail}
                  />
                </Input.Root>

                <Input.Root className="mt-5">
                  <Input.Label className="has-text-grey pl-5" style={{ marginBottom: 0 }} htmlFor="password">
                    Senha
                  </Input.Label>
                  <Input.Prompt
                    id="password"
                    className="is-rounded"
                    type="password"
                    placeholder="Digite sua senha"
                    required
                    value={password}
                    setValue={setPassword}
                  />
                </Input.Root>

                {/* Botão de Excluir */}
                <Button.Bt
                  className="is-danger is-fullwidth is-rounded mt-6"
                  type="submit"
                  loading={loading}
                  action={async () => {
                    handleLogin()
                  }}
                >
                  Excluir conta
                </Button.Bt>
              </Form.Root>

              {/* Botão de retorno ou ações adicionais */}
              <div style={{ height: 100 }}></div>
              <Button.A className="is-link is-fullwidth mt-6" link={Path.CollabLogin}>
                Voltar para a Página Inicial
              </Button.A>
              <div style={{ height: 400 }}></div>
              <AlertFunctional values={alerts} setValues={setAlerts} />
            </Column.Content>
          </Column.Root>
        </div>
      </Page.Content>
    </Page.Root>
  )
}

export default DeleteAccount
